import { gql } from '../../__generated__';

export const EXISTING_GIGYA_ACCOUNT = gql(`
    query ExistingGigyaAccount($input: ExistingGigyaAccountInput!) {
        existingGigyaAccount(input: $input) {
            emailExists
        }
    }
`);
